import styled, { keyframes, css } from 'styled-components'
import { PaddingContainer, GridMixin } from 'components/common/common_styles'
import GImage from 'components/common/gImage'
import TitleColumn from 'components/common/titleColumn'
import { sizeMobile, gutter } from 'components/globalStyles'

export const MainContainer = styled(PaddingContainer)`
  ${GridMixin};
  grid-template-columns: repeat(auto-fit, minmax(20ch, auto));
`

export const TitleContainer = styled(TitleColumn)`
  @media (max-width: ${sizeMobile}) {
    padding-left: ${gutter};
    padding-right: ${gutter};
    margin-bottom: 48px;
  }
`

export const ImageContainer = styled.div`
  ${GridMixin};
  justify-items: center;
  align-items: center;
  max-width: 700px;

  & > * {
    grid-area: 1 / -1;
    z-index: 0;
  }

  @media (max-width: ${sizeMobile}) {
    padding-right: ${gutter};
  }
`

export const SeasonImage = styled(GImage)`
  grid-area: 1 / -1;
  transform: translateZ(0);
  border-radius: 50%;
  width: 78%;
  height: 78%;
`

export const ImageDecoration = styled.img`
  justify-self: end;
  align-self: end;
  width: 32%;
  opacity: 75%;
`

const pathWipe = keyframes`
  from {
    stroke-dashoffset: 3770;
  }
  to {
    stroke-dashoffset: 0;
  }
`

export const MaskPath = styled.path`
  ${props => props.play && css`
    animation: ${pathWipe} 2s ease 0s 1 normal both;
  `}
`

export const MobileListContainer = styled.div`
  margin-left: ${gutter};
  margin-top: 24px;
`
